/**
 * Shikoyat sheeti — **faza 3 qabul mezoni: UCH BOSISH.**
 *
 *   1. shikoyat tugmasi  →  sheet ochiladi
 *   2. sabab             →  ro'yxatdan bitta
 *   3. Yuborish
 *
 * Izoh maydoni ATAYLAB yo'q. Uni qo'shish oqimni to'rt bosishga
 * cho'zardi (klaviatura, yozish, yopish) va ko'p odam shikoyatni
 * tashlab ketardi. Server `comment` ni qabul qiladi, lekin u ixtiyoriy
 * va bu ekran undan foydalanmaydi.
 *
 * Sheet `blur-sheet` bilan — bu ruxsat etilgan 4 blur joyidan biri
 * (qoida 15, sovg'a sheeti bilan bir sinf).
 */

import { useState } from 'react';

import { uz } from '../i18n/uz';
import { useSendReport, type ReportBody } from '../lib/api/useSocial';
import { CTAButton, Chip } from '../ui';
import './screens.css';

type Reason = 'spam' | 'harassment' | 'adult' | 'scam' | 'underage' | 'other';

const REASONS: Reason[] = ['spam', 'harassment', 'adult', 'scam', 'underage', 'other'];

export function ReportSheet({
  targetUserId,
  context,
  roomId,
  onClose,
  onSent,
  onFailed,
}: {
  targetUserId: number;
  context: ReportBody['context'];
  roomId?: number;
  onClose: () => void;
  onSent: () => void;
  onFailed: () => void;
}) {
  const [reason, setReason] = useState<Reason>('spam');
  const send = useSendReport();

  async function submit(): Promise<void> {
    const body: ReportBody = { target_user_id: targetUserId, context, reason };
    if (roomId !== undefined) body.room_id = roomId;

    try {
      await send.mutateAsync(body);
      onSent();
    } catch {
      onFailed();
    } finally {
      // Muvaffaqiyatda ham, xatoda ham yopiladi: shikoyat oynasi
      // ochiq qolsa odam uni qayta-qayta yuborardi.
      onClose();
    }
  }

  return (
    <>
      <div className="sheet-backdrop" onClick={onClose} role="presentation" />
      <div className="sheet blur-sheet" role="dialog" aria-label={uz.report.title}>
        <div className="sheet__handle" />
        <div className="report__title">{uz.report.title}</div>
        <p className="report__hint">{uz.report.hint}</p>

        <div className="chip-row report__reasons">
          {REASONS.map((value) => (
            <Chip key={value} active={reason === value} onClick={() => setReason(value)}>
              {uz.report[value]}
            </Chip>
          ))}
        </div>

        <div style={{ marginTop: 18 }}>
          <CTAButton variant="danger" onClick={() => void submit()} disabled={send.isPending}>
            {uz.report.send}
          </CTAButton>
        </div>
      </div>
    </>
  );
}
